export const MAX_INSURANCE_FILE_SIZE = 25 * 1024 * 1024;
